/** ستون‌های قابل ارجاع در فرمول (مثل سلول‌های اکسل در همان ردیف) */
export type PayrollSpreadsheetColumnId =
  | 'present_days'
  | 'base_salary'
  | 'worked_salary'
  | 'absence_deduction'
  | 'overtime_hours'
  | 'overtime_hourly_rate'
  | 'manual_advance_deduction'
  | 'manual_incentive';

export type PayrollSpreadsheetColumn = {
  id: PayrollSpreadsheetColumnId;
  /** حرف ستون (نمایشی) */
  letter: string;
  label: string;
  /** نام متغیر در فرمول */
  variable: string;
  pickable: boolean;
};

export const PAYROLL_SPREADSHEET_COLUMNS: PayrollSpreadsheetColumn[] = [
  { id: 'present_days', letter: 'C', label: 'حاضر', variable: 'present_days', pickable: true },
  { id: 'base_salary', letter: 'D', label: 'حقوق پایه', variable: 'base_salary', pickable: true },
  { id: 'worked_salary', letter: 'E', label: 'کارکرد', variable: 'worked_salary', pickable: true },
  { id: 'absence_deduction', letter: 'F', label: 'کسر غیبت', variable: 'absence_deduction', pickable: true },
  { id: 'overtime_hours', letter: 'G', label: 'اضافه (س)', variable: 'overtime_hours', pickable: true },
  { id: 'overtime_hourly_rate', letter: 'H', label: 'نرخ اضافه', variable: 'overtime_hourly_rate', pickable: true },
  { id: 'manual_advance_deduction', letter: 'I', label: 'مساعده/کسور', variable: 'manual_advance_deduction', pickable: true },
  { id: 'manual_incentive', letter: 'J', label: 'تشویقی', variable: 'manual_incentive', pickable: true },
];

export const PAYROLL_NET_COLUMN_LETTER = 'K';

export function columnById(id: PayrollSpreadsheetColumnId): PayrollSpreadsheetColumn {
  return PAYROLL_SPREADSHEET_COLUMNS.find((c) => c.id === id)!;
}
